import type { ButtonConfig } from '../../declare'
import { useState, useContext } from 'react'
import { Popconfirm, Button } from 'antd'
import { EasyIcon, ListPropsContext, postMsg } from 'src/components'
import { appStore, listStore } from 'src/stores'
import { $api } from 'src/plugins'
import { initFilter } from 'src/utils/common'

type Props = {
  config: ButtonConfig
}

const CustomEvtBtn = (props: Props) => {
  const table = listStore.table.get(useContext(ListPropsContext).formCode)

  const [loading, setLoading] = useState(false)
  const handleConfirm = () => {
    const { API_URL } = props.config
    if (!API_URL) {
      postMsg('未配置API接口', 'error')
      return
    }

    const { OrgId } = appStore.current.headers
    const payload = initFilter({ OrgId })

    setLoading(true)
    $api['app/getDataByPost'](payload,
      { url: API_URL }
    ).then((res: any) => {
      if (res) {
        table.reload()
        postMsg('操作成功')
      }
    }).finally(() => {
      setLoading(false)
    })
  }

  const { LABEL, ICON } = props.config
  return (
    <Popconfirm title='是否确认执行？' onConfirm={handleConfirm}>
      <Button
        type='primary'
        icon={<EasyIcon type={ICON} defaultIcon='CloudSyncOutlined' />}
        loading={loading}
      >{LABEL}</Button>
    </Popconfirm>
  )
}

export default CustomEvtBtn